import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getEmploymentStatuses } from "../../actions/userActions/employmentStatusAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton, Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HeaderComponent from "../reuse_components/HeaderComponent";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import SearchInput from "../subComponents/search/SearchInput";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import CustomButton from "../subComponents/buttons/CustomButton";

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import AddEmploymentStatuses from "./AddEmploymentStatuses";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EmploymentStatuses() {
  const query = useQuery();
  const [isExpanded, setIsExpanded] = useState(false);
  const initialPageNumber = parseInt(query.get("page")) || 1;
  const [currentPageNumber, setCurrentPageNumber] = useState(initialPageNumber);
  const [searchQuery, setSearchQuery] = useState(query.get("search") || "");
  const [previousQuery, setPreviousQuery] = useState("");
  const [permission, setPermission] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [EmployementStatusData, setEmployementStatusData] = useState([]);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    const pageNumber = currentPageNumber;

    if (searchQuery !== previousQuery) {
      setCurrentPageNumber(1);
    }
    dispatch(getEmploymentStatuses(pageNumber, itemsPerPage, searchQuery));
    setPreviousQuery(searchQuery);
    setButtonPermission()
  }, [currentPage, searchQuery]);

  const employmentStatuses = useSelector(
    (state) => state.employmentStatuses_reducer.employmentStatuses
  );
   const totalPages = employmentStatuses?.totalPages || 0;
  const totalItems = employmentStatuses?.totalCount || 0;

  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  const isLoading =  useSelector((state) => state.employmentStatuses_reducer.isEmploymentStatusLoading);

  useEffect(() => {
    const EmploymentStatusData =
      employmentStatuses && employmentStatuses?.result?.map((employmentStatuses) => ({
        ...employmentStatuses,
        status: (
          <span className={employmentStatuses.active ? "status-badge-active" : "status-badge-inactive"}>
            {employmentStatuses.active ? "Active" : "Inactive"}
          </span>
        ),
      })) || [];
    setEmployementStatusData(EmploymentStatusData);
  }, [employmentStatuses]);
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    { label: `${t("status")}`, accessor: "status" },
  ];

  const handleAddEmployeementStatusClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditEmploymentStatus = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getEmploymentStatuses(currentPage, itemsPerPage, searchQuery));
    setShowModal(false);
  };
  const actions = [
    {
      label: 'Edit Employment status',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateEmploymentStatus',
      handler: handleEditEmploymentStatus,
    },
  ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const setButtonPermission = () => {
    if (permissions.includes('CanAddEmploymentStatus')) {
      setPermission(true);
    }
  }
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getEmploymentStatuses(pageNumber, value, searchQuery));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  return (
    <>

      <div>
        <LoadingOverlay isVisible={isLoading} />
        <div className="main-container">
          <div className="content-wrapper">
            <div className="pagination">
              <SearchInput
                placeholder="Search"
                onChange={handleSearchChange}
                value={searchQuery}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />

                {permissions && permissions.includes("CanAddEmploymentStatus") && (
                  <CustomButton text={t("addNew")} onClick={handleAddEmployeementStatusClick} />
                )}
              </div>
            </div>
           
          </div>
          <DynamicTable
              data={EmployementStatusData}
              columns={columns}
              permissions={permissions}
              actions={actions}
              thIcon={thIcon}
              showPagination={totalItems > 0}
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              totalPages={totalPages}
              onPageChange={(page) => setCurrentPage(page)}
              onItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>

        {showModal && (
          <AddEmploymentStatuses
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>

    </>
  );
}

export default EmploymentStatuses;
